import {readUnitAutoSelectionEnabled} from "../../../utils/unitAutoSelection/unitAutoSelectionSetting";

// Автовыбор отрядов и пропуск хода на этапах войны (change unit-auto-selection).
// Все здесь — только у клиента: в состояние партии, протокол и запись матча
// не попадает.
//
//  - skipKey и skippedUnitIds — отряды, пропустившие ход на этапе. Ключ —
//    раунд, фаза, этап и игрок (getUnitTurnSkipKey): пропуски действуют, только
//    пока ключ совпадает с текущим этапом (selectSkippedUnitIds), поэтому
//    снимать их при смене этапа или игрока в hot-seat не нужно. Пропуск с
//    другим ключом начинает список заново;
//  - isEnabled — тумблер «Автовыбор отрядов»; начальное значение — из браузера
const getInitialState = () => ({
  skipKey: null,
  skippedUnitIds: [],
  isEnabled: readUnitAutoSelectionEnabled(),
});

const unitAutoSelectionReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case 'SKIP_UNIT_TURN': {
      const {unitId, skipKey} = action.payload;
      if (state.skipKey !== skipKey) {
        return {...state, skipKey, skippedUnitIds: [unitId]};
      }
      if (state.skippedUnitIds.includes(unitId)) {
        return state;
      }
      return {...state, skippedUnitIds: [...state.skippedUnitIds, unitId]};
    }
    case 'SET_UNIT_AUTO_SELECTION_ENABLED':
      return state.isEnabled === action.payload.isEnabled ? state : {...state, isEnabled: action.payload.isEnabled};
    default:
      return state;
  }
};

export default unitAutoSelectionReducer;
